import { useState } from 'react'
import { PlusIcon } from '@heroicons/react/24/outline'
import { productsAPI, VendorProduct } from '../../lib/services'

interface ProductCatalogProps {
  products: VendorProduct[]
  vendorId: number
  onProductClick: (product: VendorProduct) => void
  onRefresh: () => void
}

export default function ProductCatalog({ products, vendorId, onProductClick, onRefresh }: ProductCatalogProps) {
  const [creating, setCreating] = useState(false)

  const handleAddProduct = async () => {
    setCreating(true)
    try {
      const newProduct = await productsAPI.create({
        vendor: vendorId,
        name: 'New Product',
        is_active: true,
      } as any)
      onRefresh()
      onProductClick(newProduct)
    } catch (err) {
      console.error('Failed to create product:', err)
    } finally {
      setCreating(false)
    }
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Product Catalog</h3>
        <span className="text-xs text-muted-foreground">{products.length} product{products.length !== 1 ? 's' : ''}</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {products.map(product => (
          <div
            key={product.id}
            onClick={() => onProductClick(product)}
            className="group border border-border rounded-lg overflow-hidden cursor-pointer hover:border-blue-500/50 hover:shadow-md transition-all bg-background"
          >
            <div className="aspect-[16/10] bg-muted flex items-center justify-center overflow-hidden">
              {product.primary_image?.image_url ? (
                <img
                  src={product.primary_image.image_url}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="text-muted-foreground text-xs">No image</div>
              )}
            </div>
            <div className="p-3">
              <h4 className="text-sm font-medium text-foreground truncate group-hover:text-blue-500 transition-colors">
                {product.name}
              </h4>
              {product.description && (
                <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
                  {product.description}
                </p>
              )}
            </div>
          </div>
        ))}

        {/* Add Product tile */}
        <div
          onClick={!creating ? handleAddProduct : undefined}
          className="border border-dashed border-border rounded-lg flex flex-col items-center justify-center py-12 cursor-pointer hover:border-blue-500/50 hover:bg-blue-500/5 transition-all"
        >
          <PlusIcon className="w-8 h-8 text-muted-foreground mb-2" />
          <span className="text-sm text-muted-foreground">
            {creating ? 'Creating...' : 'Add Product'}
          </span>
        </div>
      </div>
    </div>
  )
}
